export const GET_PROCEDURE_RESULT_DETAILS = 'GET_PROCEDURE_RESULT_DETAILS';
export const GET_PROCEDURE_TYPE = 'GET_PROCEDURE_TYPE';

export const GET_PROCESS_DETAILS = 'GET_PROCESS_DETAILS';
// export const PROCEDURE_PROVIDER_NETWORK_DELETE = 'PROCEDURE_PROVIDER_NETWORK_DELETE';
